export const getData = (data: any, key: string, prop: string) => {
    const a: any = data.find((x: any) => x.key === key);
    return typeof a !== 'undefined' ? a[prop] : null;
};

export const getLabels = (data: any) =>
    data.reduce((acc: any, x: any) => [...acc, x.data], []).map((y: any) => y.label);
